import {
  GET_ARTICULOS,
  FETCH_ARTICULOS,
  GET_MAS_ARTICULOS,
  GET_OFERTAS,
  GET_NOVEDADES,
  GET_PEDIDO_HABITUAL,
  GET_RELACIONADOS,
  CHANGE_ARTICULOS_PAGINA,
  SET_BUSQUEDA,
  CHANGE_ARTICULOS_ORDEN,
  GET_STOCK_ARTICULO,
  FETCH_MAS_ARTICULOS,
} from "../actions/types.js";

const initialState = {
  articulos: {
    articulos: [],
    articulos_total: 0,
    articulos_siguiente: "",
    articulos_anterior: "",
    filtros_aplicables: [],
  },
  ofertas: {
    articulos: [],
    articulos_total: 0,
    articulos_siguiente: "",
    articulos_anterior: "",
  },
  novedades: {
    articulos: [],
    articulos_total: 0,
    articulos_siguiente: "",
    articulos_anterior: "",
  },
  pedido_habitual: {
    articulos: [],
    articulos_total: 0,
    articulos_siguiente: "",
    articulos_anterior: "",
  },
  relacionados: {
    articulos: [],
    articulos_total: 0,
    articulos_siguiente: "",
    articulos_anterior: "",
  },
  articulos_pagina: 12,
  articulos_search: "",
  articulos_orden: "",
  isLoading: false,
};

export default function (state = initialState, action) {
  let articulos_nuevo;
  let pedido_habitual_nuevo;
  let novedades_nuevo;
  let ofertas_nuevo;
  let relacionados_nuevo;
  let mas_articulos;

  switch (action.type) {
    case FETCH_MAS_ARTICULOS:
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_ARTICULOS:
      return {
        articulos: {
          articulos: [],
          articulos_total: 0,
          articulos_siguiente: "",
          articulos_anterior: "",
          filtros_aplicables: [],
        },
        ofertas: {
          articulos: [],
          articulos_total: 0,
          articulos_siguiente: "",
          articulos_anterior: "",
        },
        novedades: {
          articulos: [],
          articulos_total: 0,
          articulos_siguiente: "",
          articulos_anterior: "",
        },
        pedido_habitual: {
          articulos: [],
          articulos_total: 0,
          articulos_siguiente: "",
          articulos_anterior: "",
        },
        relacionados: {
          articulos: [],
          articulos_total: 0,
          articulos_siguiente: "",
          articulos_anterior: "",
        },
        articulos_pagina: 12,
        articulos_search: "",
        articulos_orden: "",
        isLoading: true,
      };
    case GET_ARTICULOS:
      articulos_nuevo = JSON.parse(JSON.stringify(state.articulos));
      articulos_nuevo.articulos = action.payload.results;
      articulos_nuevo.articulos_total = action.payload.count;
      articulos_nuevo.articulos_siguiente = action.payload.next;
      articulos_nuevo.articulos_anterior = action.payload.previous;
      articulos_nuevo.filtros_aplicables = action.payload.filtros_aplicables;
      return {
        ...state,
        articulos: articulos_nuevo,
        articulos_search: action.payload.search,
        articulos_pagina: action.payload.articulos_pagina,
        articulos_orden: action.payload.articulos_orden,
        isLoading: false,
      };
    case GET_PEDIDO_HABITUAL:
      pedido_habitual_nuevo = JSON.parse(JSON.stringify(state.pedido_habitual));
      pedido_habitual_nuevo.articulos = action.payload.results;
      pedido_habitual_nuevo.articulos_total = action.payload.count;
      pedido_habitual_nuevo.articulos_siguiente = action.payload.next;
      pedido_habitual_nuevo.articulos_anterior = action.payload.previous;
      return {
        ...state,
        pedido_habitual: pedido_habitual_nuevo,
        articulos_search: "",
        articulos_pagina: 12,
        articulos_orden: "",
        isLoading: false,
      };

    case GET_NOVEDADES:
      novedades_nuevo = JSON.parse(JSON.stringify(state.novedades));
      novedades_nuevo.articulos = action.payload.results;
      novedades_nuevo.articulos_total = action.payload.count;
      novedades_nuevo.articulos_siguiente = action.payload.next;
      novedades_nuevo.articulos_anterior = action.payload.previous;
      return {
        ...state,
        novedades: novedades_nuevo,
        articulos_search: "",
        articulos_pagina: 12,
        articulos_orden: "",
        isLoading: false,
      };
    case GET_OFERTAS:
      ofertas_nuevo = JSON.parse(JSON.stringify(state.ofertas));
      ofertas_nuevo.articulos = action.payload.results;
      ofertas_nuevo.articulos_total = action.payload.count;
      ofertas_nuevo.articulos_siguiente = action.payload.next;
      ofertas_nuevo.articulos_anterior = action.payload.previous;
      return {
        ...state,
        ofertas: ofertas_nuevo,
        articulos_search: "",
        articulos_pagina: 12,
        articulos_orden: "",
        isLoading: false,
      };
    case GET_RELACIONADOS:
      relacionados_nuevo = JSON.parse(JSON.stringify(state.relacionados));
      relacionados_nuevo.articulos = action.payload.results;
      relacionados_nuevo.articulos_total = action.payload.count;
      relacionados_nuevo.articulos_siguiente = action.payload.next;
      relacionados_nuevo.articulos_anterior = action.payload.previous;
      return {
        ...state,
        relacionados: relacionados_nuevo,
        articulos_search: "",
        articulos_pagina: 12,
        articulos_orden: "",
        isLoading: false,
      };
    case GET_MAS_ARTICULOS:
      switch (action.origen) {
        case "articulos":
          mas_articulos = JSON.parse(JSON.stringify(state.articulos));
          mas_articulos.articulos = [
            ...mas_articulos.articulos,
            ...action.payload.results,
          ];
          mas_articulos.articulos_siguiente = action.payload.next;
          mas_articulos.articulos_anterior = action.payload.previous;
          return {
            ...state,
            articulos: mas_articulos,
            isLoading: false,
          };
        case "pedido_habitual":
          mas_articulos = JSON.parse(JSON.stringify(state.pedido_habitual));
          mas_articulos.articulos = [
            ...mas_articulos.articulos,
            ...action.payload.results,
          ];
          mas_articulos.articulos_siguiente = action.payload.next;
          mas_articulos.articulos_anterior = action.payload.previous;
          return {
            ...state,
            pedido_habitual: mas_articulos,
            isLoading: false,
          };
        case "novedades":
          mas_articulos = JSON.parse(JSON.stringify(state.novedades));
          mas_articulos.articulos = [
            ...mas_articulos.articulos,
            ...action.payload.results,
          ];
          mas_articulos.articulos_siguiente = action.payload.next;
          mas_articulos.articulos_anterior = action.payload.previous;
          return {
            ...state,
            novedades: mas_articulos,
            isLoading: false,
          };
        case "ofertas":
          mas_articulos = JSON.parse(JSON.stringify(state.ofertas));
          mas_articulos.articulos = [
            ...mas_articulos.articulos,
            ...action.payload.results,
          ];
          mas_articulos.articulos_siguiente = action.payload.next;
          mas_articulos.articulos_anterior = action.payload.previous;
          return {
            ...state,
            ofertas: mas_articulos,
            isLoading: false,
          };
      }
      return {
        ...state,
        isLoading: false,
      };

    case SET_BUSQUEDA:
      return {
        ...state,
        articulos_search: action.payload,
      };
    case CHANGE_ARTICULOS_PAGINA:
      return {
        ...state,
        articulos_pagina: action.payload,
      };
    case CHANGE_ARTICULOS_ORDEN:
      return {
        ...state,
        articulos_orden: action.payload,
      };
    case GET_STOCK_ARTICULO:
      let index;

      articulos_nuevo = JSON.parse(JSON.stringify(state.articulos));

      index = articulos_nuevo.articulos.findIndex(
        (articulo) => articulo.codigo_articulo === action.codigo_articulo
      );

      if (index !== -1) {
        articulos_nuevo.articulos[index]["info_stock"] = action.payload;
      }

      pedido_habitual_nuevo = JSON.parse(JSON.stringify(state.pedido_habitual));

      index = pedido_habitual_nuevo.articulos.findIndex(
        (articulo) => articulo.codigo_articulo === action.codigo_articulo
      );

      if (index !== -1) {
        pedido_habitual_nuevo.articulos[index]["info_stock"] = action.payload;
      }
      novedades_nuevo = JSON.parse(JSON.stringify(state.novedades));

      index = novedades_nuevo.articulos.findIndex(
        (articulo) => articulo.codigo_articulo === action.codigo_articulo
      );

      if (index !== -1) {
        novedades_nuevo.articulos[index]["info_stock"] = action.payload;
      }
      ofertas_nuevo = JSON.parse(JSON.stringify(state.ofertas));

      index = ofertas_nuevo.articulos.findIndex(
        (articulo) => articulo.codigo_articulo === action.codigo_articulo
      );

      if (index !== -1) {
        ofertas_nuevo.articulos[index]["info_stock"] = action.payload;
      }
      relacionados_nuevo = JSON.parse(JSON.stringify(state.relacionados));

      index = relacionados_nuevo.articulos.findIndex(
        (articulo) => articulo.codigo_articulo === action.codigo_articulo
      );
      if (index !== -1) {
        relacionados_nuevo.articulos[index]["info_stock"] = action.payload;
      }

      return {
        ...state,
        articulos: articulos_nuevo,
        pedido_habitual: pedido_habitual_nuevo,
        novedades: novedades_nuevo,
        ofertas: ofertas_nuevo,
        relacionados: relacionados_nuevo,
        articulos_search: action.payload.search,
        articulos_pagina: action.payload.articulos_pagina,
        articulos_orden: action.payload.articulos_orden,
        isLoading: false,
      };
    default:
      return state;
  }
}
